<template>
  <GModal v-if="showModal" class="custom-modal modal--product-combination" :noscroll="true">
    <div slot="header">
      <button type="button" class="close hidden-mobile" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="SOCO" @click.prevent="close" />
      </button>
      <h2 class="modal-heading">
        <img v-if="!screen.isDesktop" src="/assets/img/icons/back-state-mobile.svg" @click.prevent="close" />
        PRODUCT COMBINATION
      </h2>
    </div>
    <div slot="body">
      <p class="text-helped">What kind of variants does this product have?</p>

      <ul class="list-attributes">
        <li @click.prevent="openProductAttribute('shade')">
          <span class="list-attributes__name">Shade</span>
          <img src="/assets/img/icons/arrow-right-variant.svg" class="list-attributes__icon" />
        </li>
        <li @click.prevent="openProductAttribute('size')">
          <span class="list-attributes__name">Size</span>
          <img src="/assets/img/icons/arrow-right-variant.svg" class="list-attributes__icon" />
        </li>
        <li @click.prevent="openProductAttribute('variant')">
          <span class="list-attributes__name">Variant</span>
          <img src="/assets/img/icons/arrow-right-variant.svg" class="list-attributes__icon" />
        </li>
        <li @click.prevent="openProductAttribute('multiple_combination')">
          <span class="list-attributes__name">Multiple Combination</span>
          <img src="/assets/img/icons/arrow-right-variant.svg" class="list-attributes__icon" />
        </li>
      </ul>

      <p class="text-info">
        <img src="/assets/img/icons/list-attributes-info.svg" class="text-info__img" />
        If there’s no variants, you can skip this step
      </p>

      <div class="row row-fix-bottom">
        <div class="col-xs-12">
          <a href="" class="btn red btn-next btn-block" @click.prevent="next">NEXT</a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-product-combination',
  computed: {
    showModal() {
      return this.$store.state.modal.isModalShow.productCombination;
    },
    screen() {
      return this.$store.state.screen;
    },
  },
  methods: {
    close() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'productCombination',
      });
    },
    next() {
      this.$emit('next', 'summary');
      this.close();
    },
    openProductAttribute(attributeName) {
      this.$emit('getAttribute', { attributeName });
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal--product-combination ::v-deep {
  .list-attributes {
    margin: 0 0 24px 0;
    > li {
      background-color: #ffffff;
      box-shadow: 0 1px 4px 0 rgba(#231f20, 0.12);
      font: 14px/17px 'lato-regular', sans-serif;
      color: #231f20;
      position: relative;
      cursor: pointer;
      display: block;
      height: 40px;
      border-radius: 4px;
      padding: 12px 12px 11px 12px;
      margin-bottom: 16px;
    }
  }

  .list-attributes__icon {
    position: absolute;
    top: 14.5px;
    right: 12px;
    z-index: 11;
  }

  .modal-dialog {
    width: 376px;
    height: 465px;
    border-radius: 4px;
    box-shadow: 1px 2px 14px 0px rgba(#231f20, 0.24);
  }

  .modal-body {
    padding-top: 0;
  }

  .modal-header {
    padding: 16px 16px 20px 16px;
    .close {
      margin: 0;
      top: 13px;
      right: 16px;
    }
  }

  .modal-heading {
    font: 13px/18px 'lato-bold', sans-serif;
    letter-spacing: 2px;
    color: #231f20;
    margin: 0;
  }

  .text-helped {
    font: 16px/28px 'lato-bold', sans-serif;
    margin: 0 0 24px 0;
    color: #231f20;
  }

  .text-info {
    font: 12px/20px 'lato-regular', sans-serif;
    color: #222;
    margin: 0 0 32px 0;
    text-align: center;
  }
}

@media (max-width: 991px) {
  .modal--product-combination ::v-deep {
    .modal {
      height: 100%;
      background-color: #ffffff;
    }

    .modal-body {
      position: absolute;
      top: 60px;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 9999;
      padding: 20px 16px;
    }

    .modal-dialog {
      width: 100%;
      height: 100%;
      border-radius: 0;
      margin: 0;
      padding: 0;
    }

    .modal-content {
      border: none;
      height: 100%;
    }

    .modal-footer {
      display: none;
    }

    .modal-header {
      padding: 16px;
      height: 60px;
    }

    .modal-header__heading {
      font: 14px/28px 'lato-bold', sans-serif;
      letter-spacing: 2px;
      margin: 0;
      color: #231f20;
      > img {
        margin-right: 20px;
      }
    }
  }
}
</style>
